import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

export type GenerateOfferIfAllowedResult = {
  allowed: boolean;
  count: number;
  limit: number;
  remaining: number;
};

function parseGeneratePayload(raw: unknown): GenerateOfferIfAllowedResult | null {
  if (!raw || typeof raw !== "object") return null;
  const o = raw as Record<string, unknown>;
  const count = Number(o.count);
  const limit = Number(o.limit);
  const remaining = Number(o.remaining);
  if (!Number.isFinite(count) || !Number.isFinite(limit) || !Number.isFinite(remaining)) {
    return null;
  }
  if (typeof o.allowed !== "boolean") return null;
  return {
    allowed: o.allowed,
    count,
    limit,
    remaining,
  };
}

/**
 * Supabase RPC `generate_offer_if_allowed`: atomowo liczy generacje w miesiącu i — jeśli miejsce —
 * dopisuje event (free tier). `requestId` z jednego kliknięcia — powtórzenie tego samego id = idempotencja (bez drugiego INSERT).
 */
export async function generateOfferIfAllowed(
  client: SupabaseClient<Database>,
  draftId: string | null,
  requestId: string
): Promise<GenerateOfferIfAllowedResult | { error: string }> {
  const { data, error } = await client.rpc("generate_offer_if_allowed", {
    p_draft_id: draftId,
    p_request_id: requestId,
  });

  if (error) {
    return { error: error.message };
  }

  const parsed = parseGeneratePayload(data);
  if (!parsed) {
    return { error: "Niepoprawna odpowiedź serwera." };
  }
  return parsed;
}
